import { ErrorState } from './types';
import { ActionErrorTypes, SET_ERROR, CLEAR_ERROR } from './actions';

const initialState: ErrorState = null;

const errorReducer = (state = initialState, { type, payload }: ActionErrorTypes) => {
	switch (type) {
		case SET_ERROR:
			return payload;
		case CLEAR_ERROR:
			return null;
		default:
			return state;
	}
};

export default errorReducer;
